import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import CustomModal from '../../components/CustomModal/CustomModal'
import { getGame } from '../../services/games'
import { trackGameEvent } from '../../utils/plausible'
import styles from './GameModal.module.css'

const LIKED_GAMES_KEY = 'tiiny_liked_games'

const getLikedGames = () => {
  try {
    return JSON.parse(localStorage.getItem(LIKED_GAMES_KEY)) || []
  } catch {
    return []
  }
}

const rememberLikedGame = (subdomain) => {
  const liked = getLikedGames()
  if (!liked.includes(subdomain)) {
    localStorage.setItem(LIKED_GAMES_KEY, JSON.stringify([...liked, subdomain]))
  }
}

const GameModal = ({ subdomain, show, onHide }) => {
  const [game, setGame] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)
  const [liked, setLiked] = useState(false)

  useEffect(() => {
    if (!show || !subdomain) return

    let cancelled = false
    setLoading(true)
    setError(false)
    setGame(null)
    setLiked(getLikedGames().includes(subdomain))

    getGame(subdomain)
      .then((data) => {
        if (!cancelled) setGame(data)
      })
      .catch(() => {
        if (!cancelled) setError(true)
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })

    return () => {
      cancelled = true
    }
  }, [subdomain, show])

  const handleLike = () => {
    if (liked || !game) return
    trackGameEvent(subdomain, 'Like')
    rememberLikedGame(subdomain)
    setLiked(true)
    setGame((prev) => (prev ? { ...prev, likes: (prev.likes || 0) + 1 } : prev))
  }

  return (
    <CustomModal show={show} onHide={onHide} size="lg" centered contentClassName={styles.modalContent}>
      <Modal.Header className={styles.detailsHeader} closeButton closeVariant="white">
        {game && <Modal.Title className={styles.title}>{game.title}</Modal.Title>}
      </Modal.Header>
      <Modal.Body className={styles.detailsBody}>
        {loading ? (
          <p>Loading...</p>
        ) : error || !game ? (
          <p>Game not found.</p>
        ) : (
          <>
            <div className={styles.thumbnailWrap}>
              <img className={styles.thumbnail} src={game.thumbnail} alt={game.title} />
              <a
                className={styles.playOverlayBtn}
                href={`https://${subdomain}`}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`Play ${game.title} in a new window`}
              >
                <i className="bi bi-play-fill" />
              </a>
            </div>

            <div className={styles.statsRow}>
              <button
                className={`${styles.statBtn} ${liked ? styles.liked : ''}`}
                onClick={handleLike}
                disabled={liked}
              >
                <i className={`bi ${liked ? 'bi-heart-fill' : 'bi-heart'}`} /> {game.likes || 0} likes
              </button>
              <span className={styles.statBtn}>
                <i className="bi bi-play-circle-fill" /> {game.plays || 0} plays
              </span>
            </div>

            <p className={styles.description}>{game.description}</p>
          </>
        )}
      </Modal.Body>
    </CustomModal>
  )
}

export default GameModal
